<template>
    <div class="px-4">
        <div class="d-flex align-items-center mb-3">
            <div class="search-box chat-search-box w-100">
                <div class="input-group rounded-5">
                    <span class="input-group-text text-muted bg-light pe-1 ps-3" style="border-radius: 20px 0px 0px 20px!important;">
                        <i class="ri-search-line search-icon font-size-18"></i>
                    </span>
                    <input   style="border-radius: 0px 20px 20px 0px!important;"
                        type="text" 
                        class="form-control bg-light" 
                        placeholder="Pesquisar conversas ..."
                        :value="modelValue"
                        @input="$emit('update:modelValue', $event.target.value)"
                    >
                </div>
            </div>

            <div class="float-end ms-2">
                <div class="dropdown dropdown-fixed">
                    <button type="button" class="btn btn-light py-2 px-3 btn-sm position-relative dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-bs-auto-close="outside">
                        <i class="ri-filter-3-line font-size-18"></i>
                    </button>
                    <div class="dropdown-menu dropdown_max_size" style="max-height: 300px; overflow:auto">
                        <h6 class="dropdown-header">Filtre suas conversas</h6>
                        <div class="dropdown-item">
                            <div class="form-check"><input class="form-check-input" type="checkbox"><label class="form-check-label font-size-13">Mostrar Todas</label></div>
                        </div>
                        <div class="dropdown-item">
                            <div class="form-check"><input class="form-check-input" type="checkbox"><label class="form-check-label font-size-13">Não Lidos</label></div>
                        </div>
                        <div class="dropdown-item">
                            <div class="form-check"><input class="form-check-input" type="checkbox"><label class="form-check-label font-size-13">Meus atendimentos</label></div>
                        </div>
                        </div>
                </div>
            </div>

            <div class="float-end ms-2">
                <div class="dropdown dropdown-fixed">
                    <button type="button" class="btn btn-light py-2 px-3 btn-sm position-relative dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-bs-auto-close="outside">
                        <i class="ri-price-tag-3-fill font-size-18"></i>
                    </button>
                    <div class="dropdown-menu">
                        <h6 class="dropdown-header">Filtrar conversas com etiquetas</h6>
                        <div class="dropdown-item">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox">
                                <label class="cursor-pointer form-check-label font-size-13">
                                    <i class="ri-price-tag-3-fill" style="color: #f20006"></i>
                                    Manchester United
                                </label>
                            </div>
                        </div>
                        </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'ListSearchFilter',
    props: {
        modelValue: String // Para usar com v-model no componente pai
    }
}
</script>

<style scoped>
.px-4 {
    padding-left: 16px !important;
    padding-right: 16px !important;
}

/* Altura padronizada */
.form-control, .btn {
    min-height: 40px; 
    border-radius: 6px !important;
}

/* Remove bordas duplicadas no input group */
.form-control {
    border-right: 0;
}
.input-group-text {
    border-left: 0;
}

.btn-light {
    border: 1px solid var(--bs-border-color);
}


.bg-light{
    background: var(--bs-light) !important;
}

</style>